import React, { Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { IDataModal } from '@/interfaces/dataModal';
import CustomerDetail from './components/customer-detail';
import { getCustomer } from '@/adapters/customer';
import { ICustomer } from '@/interfaces/customer';
import { Tabs, TabsProps } from 'antd';
import Card from '@/components/card';
import CustomerRemark from './components/customer-remark';
import CustomerLogistic from './shipping-address';
// import CustomerQuotation from './quotation';
import CustomerAddModal from '../search/components/customer-add-modal';
import CustomerTemplate from './templates';
import CustomerOrder from './customer-order';
import PricesSales from './price-sales';

const _modal: IDataModal<ICustomer> = {
  open: false,
};

const CustomerMaintain = () => {
  const { id } = useParams();
  const [dataModal, setDataModal] = useState<IDataModal<ICustomer>>(_modal);
  const { data, isLoading, refetch } = useQuery<
    AxiosResponse<ICustomer>,
    Error
  >({
    queryKey: ['search-customer-detail'],
    queryFn: async () => await getCustomer(Number(id)),
  });

  const driver = data?.data;

  useEffect(() => {
    if (isLoading && driver) {
      setDataModal({
        ...dataModal,
        item: driver,
        id: driver.id,
      });
    }
  }, [driver, isLoading]);

  const items: TabsProps['items'] = [
    {
      key: 'remark',
      label: 'บันทึกช่วยจำ',
      children: (
        <Suspense>
          {data?.data && (
            <CustomerRemark data={data?.data || ({} as ICustomer)} />
          )}
        </Suspense>
      ),
    },
    {
      key: 'shipto',
      label: 'ที่อยู่จัดส่ง',
      children: data?.data && (
        <CustomerLogistic data={data?.data || ({} as ICustomer)} />
      ),
    },
    {
      key: 'order',
      label: 'ออเดอร์',
      children: data?.data && (
        <CustomerOrder data={data?.data || ({} as ICustomer)} />
      ),
    },
    {
      key: 'templates',
      label: 'ตั้งค่ารายการเอกสาร',
      children: data?.data && (
        <CustomerTemplate data={data?.data || ({} as ICustomer)} />
      ),
    },
    {
      key: 'price-sales',
      label: 'Price Sales',
      children: data?.data && (
        <PricesSales data={data?.data || ({} as ICustomer)} />
      ),
    },
  ];

  return (
    <>
      <CustomerDetail
        data={data?.data}
        onEdit={() => {
          setDataModal({
            ...dataModal,
            item: data?.data,
            id: data?.data?.id,
            open: true,
          });
        }}
      />
      <Card>
        <div className="flex flex-col gap-4">
          <Tabs
            defaultActiveKey="1"
            items={items}
            className="w-full"
            rootClassName="font-medium"
          />
        </div>
      </Card>
      <Suspense>
        <CustomerAddModal
          handleCancel={() => setDataModal({ ..._modal })}
          handleOk={() => {
            refetch();
            setDataModal({ ..._modal });
          }}
          dataModal={dataModal}
        />
      </Suspense>
    </>
  );
};

export default CustomerMaintain;
